/**
 * Constantes do Início do portal (PR 5), fora dos arquivos de componente para
 * o fast refresh do Vite continuar recarregando só o componente editado.
 */

/** Rótulos dos tipos de post da Central — os mesmos da `PortalCentralFeedPage`. */
export const TIPO_DO_COMUNICADO: Record<string, string> = {
  aviso: "Aviso",
  evento: "Evento",
  mensagem: "Mensagem",
  informacao: "Informação",
};

/** Quantas notificações a variante compacta mostra antes do "Ver todas". */
export const LIMITE_COMPACTO = 3;
